export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f0930a24ded92edc58fb7bac7c87f30f6bfa27e2e&name=fetchTypeahead!'